import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { License, LicenseTypes, FrequencyTypes } from '../models/license';
import { HttpClient } from '@angular/common/http';
import { LicenseService } from '../license.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-new-license',
  templateUrl: './new-license.component.html',
  styleUrls: ['./new-license.component.css'],
})
export class NewLicenseComponent implements OnInit {
  @Input() acc_id: number;
  @Input() allowedLicenseTypes: any[];
  @Output() submitted: EventEmitter<License> = new EventEmitter<License>();

  nextcredit = new FormControl(new Date());
  expires = new FormControl();
  license: License = new License();
  form: FormGroup;
  error: string;
  licenseTypes: any = [
    { name: 'selftest bundle', value: LicenseTypes.SELFTESTBUNDLE },
    { name: 'hearspeech standard', value: LicenseTypes.HEARSPEECHSTANDARD },
    { name: 'hearscope standard', value: LicenseTypes.HEARSCOPE },
    { name: 'hearscreen standard', value: LicenseTypes.HEARSCREENSTANDARD },
    { name: 'heartest standard', value: LicenseTypes.HEARTESTSTANDARD },
    { name: 'heartest occhealth standard', value: LicenseTypes.HEARTEST_OCCHEALTH_STANDARD },
    { name: 'peekacuity standard', value: LicenseTypes.PEEKACUITYSTANDARD },
    { name: 'vision standard', value: LicenseTypes.VISIONSTANDARD },
    { name: 'sealcheck standard', value: LicenseTypes.SEALCHECKSTANDARD },
    { name: 'sealcheck standard variphone', value: LicenseTypes.SEALCHECKSTANDARD_VARIPHONE },
    { name: 'hearkiosk din', value: LicenseTypes.HEARKIOSKDIN },
    { name: 'hearkiosk pta', value: LicenseTypes.HEARKIOSKPTA },
  ];

  frequencies: any = [
    { name: 'monthly', value: FrequencyTypes.MONTHLY },
    { name: 'annually', value: FrequencyTypes.ANNUALLY },
  ];

  constructor(
    private http: HttpClient,
    private licenseService: LicenseService,
    public snackBar: MatSnackBar,
    private _fb: FormBuilder
  ) {
    // this.form = new FormGroup({
    //   type: new FormControl(),
    //   account_id: new FormControl(),
    //   track_credits: new FormControl(false),
    //   credits_per_frequency: new FormControl(),
    //   credits_frequency: new FormControl(),
    //   next_credit: new FormControl(),
    //   expires_at: new FormControl(),
    //   active: new FormControl(true),
    // });
  }

  ngOnInit() {
    console.log('allowedLicenseTypes', this.allowedLicenseTypes);

    this.form = this._fb.group({
      type: [null, Validators.required],
      account_id: [this.acc_id, Validators.required],
      track_credits: false,
      credits_per_frequency: null,
      credits_frequency: null,
      next_credit: null,
      expires_at: null,
      active: true,
    });

    if (this.allowedLicenseTypes && this.allowedLicenseTypes.length > 0) {
      this.licenseTypes = this.allowedLicenseTypes;
    }

    this.form.get('track_credits').valueChanges.subscribe(track_credits => {
      console.log('track_credits changed', track_credits);

      if (track_credits) {
        this.form.get('credits_per_frequency').setValue(0);
        this.form.get('credits_frequency').setValue('year');
        this.form.get('next_credit').setValue(new Date());
      } else {
        this.form.get('credits_per_frequency').setValue(null);
        this.form.get('credits_frequency').setValue(null);
        this.form.get('next_credit').setValue(null);
        this.form.get('expires_at').setValue(null);
      }
    });
  }

  submit() {
    this.error = '';

    const l = new License();
    if (!!this.acc_id) {
      l.account_id = this.acc_id;
    } else {
      l.account_id = this.form.get('account_id').value;
    }

    l.type = this.form.get('type').value;
    l.track_credits = this.form.get('track_credits').value;
    l.frequency = this.form.get('credits_frequency').value;
    l.credits = this.form.get('credits_per_frequency').value;

    if (this.nextcredit.value) {
      this.license.next_credit =
        this.nextcredit.value.getFullYear() +
        '-' +
        ('0' + (this.nextcredit.value.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + this.nextcredit.value.getDate()).slice(-2);
    }

    l.next_credit = this.form.get('next_credit').value;
    if (l.next_credit) {
      const a = new Date(l.next_credit);
      l.next_credit =
        a.getFullYear() +
        '-' +
        ('0' + (a.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + a.getDate()).slice(-2);
    }
    l.expires = this.form.get('expires_at').value;
    if (l.expires) {
      const a = new Date(l.expires);
      l.expires =
        a.getFullYear() +
        '-' +
        ('0' + (a.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + a.getDate()).slice(-2);
    }
    l.active = this.form.get('active').value;

    console.log(l);

    this.licenseService.saveLicense(l).subscribe(
      data => {
        this.submitted.emit(data);
        this.snackBar.open('success', '', {
          duration: 1250,
          verticalPosition: 'top',
          horizontalPosition: 'end',
        });
      },
      error => {
        this.snackBar.open('something went wrong', '', {
          duration: 1250,
          verticalPosition: 'top',
          horizontalPosition: 'end',
        });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/new-license/new-license.component.ts